// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"9":"27ed3d97","42":"77ab3fbe","472":"cc570f6e","487":"fe73e2b8","940":"acc4a758","945":"f7e8b1ba"}[chunkId] + ".css";
};